export default __webpack_public_path__ + "static/media/listItem4.77ac7188.svg";